import { Toast } from "@al/akui-mobile";
import React, { Fragment } from "react";

import { infinityCookieOptions } from "~/common/dict/base";

/**
 * @name 获取图片后缀携带的宽高信息
 * @param {string} name `width`或者`height`
 * @param {string} str 图片src
 */
export const getImgParam = (name, str) => {
  if (!str) return null;
  const regExp = `(${name})=([0-9]+)`;
  const reg = new RegExp(regExp, "i");
  const r = str.match(reg);
  if (r !== null) return r[2];
  return null;
};

/**
 * 获取图片的宽高尺寸，根据图片链接、宽或者高 来获取图片宽高信息
 * @param {string} src 图片链接上必须要存在图片的宽高信息
 * @param {string | number | undefined=} width
 * @param {string | number | undefined=} height
 */
export const getImageSize = (src, width, height) => {
  if (!src) {
    throw Error("图片链接不存在");
  }
  if (!width && !height) {
    throw Error("width或height至少需要一个");
  }
  // 1 有宽高直接返回宽高
  if (width && height) {
    return { width, height };
  }
  // 获取图片
  const src_width = getImgParam("width", src),
    src_height = getImgParam("height", src);

  // 图片链接上必须要存在图片的宽高信息
  if (!src_width || !src_height) {
    return { width, height };
  }

  if (width || !height) {
    // 只有宽则推导出高
    const real_width_number = parseFloat(width + "");
    const real_height_number = (real_width_number * Number(src_height)) / Number(src_width);
    const length = real_width_number.toString().length;
    const unit = (width + "").substring(length);
    return {
      width: width,
      height: unit ? `${real_height_number}${unit}` : real_height_number,
    };
  } else if (height) {
    // 只有高则推导出宽
    const real_height_number = parseFloat(height + "");
    const real_width_number = (real_height_number * Number(src_width)) / Number(src_height);
    const length = real_height_number.toString().length;
    const unit = (height + "").substring(length);
    return {
      width: unit ? `${real_width_number}${unit}` : real_width_number,
      height,
    };
  }
};

export const isIos = () => {
  return process.browser && /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
};

/**
 * 获取cookie options设置参数
 * @param {any} req 服务端
 */
export function getCookieOpts(req) {
  const hostname = process.server ? req.hostname : location.hostname;
  const opts =
    process.env.BUILD_ENV === "local"
      ? { ...infinityCookieOptions }
      : {
          domain: ".silvrr.com",
          ...infinityCookieOptions,
        };

  return opts;
}

/**
 * 根据时间转化为几小时前，几天前，几月前等
 *
 */
export function getDateDiff(dateTimeStamp, t) {
  const minute = 1000 * 60;
  const hour = minute * 60;
  const day = hour * 24;
  const halfamonth = day * 15;
  const month = day * 30;
  const year = month * 12;
  const now = new Date().getTime();
  const diffValue = now - dateTimeStamp;
  if (diffValue < 0) {
    return;
  }
  const yearC = diffValue / year;
  const monthC = diffValue / month;
  const weekC = diffValue / (7 * day);
  const dayC = diffValue / day;
  const hourC = diffValue / hour;
  const minC = diffValue / minute;
  let result = "";
  let resultObj = {};
  if (yearC >= 1) {
    resultObj = {
      value: parseInt(yearC),
      label: "年前",
    };
  } else if (monthC >= 1) {
    resultObj = {
      value: parseInt(monthC),
      label: "月前",
    };
  } else if (weekC >= 1) {
    resultObj = {
      value: parseInt(weekC),
      label: "周前",
    };
  } else if (dayC >= 1) {
    resultObj = {
      value: parseInt(dayC),
      label: "天前",
    };
  } else if (hourC >= 1) {
    resultObj = {
      value: parseInt(hourC),
      label: "小时前",
    };
  } else if (minC >= 1) {
    resultObj = {
      value: parseInt(minC),
      label: "分钟前",
    };
  } else {
    result = "刚刚";
  }
  return {
    result: result === "" ? "" + resultObj.value + resultObj.label : result,
    resultObj,
    yearC: parseInt(yearC),
    monthC: parseInt(monthC),
    weekC: parseInt(weekC),
    dayC: parseInt(dayC),
    hourC: parseInt(hourC),
    minC: parseInt(minC),
  };
}

// 公共调取接口方法
export const commonRequest = async ({ dispatch, fn, request }) => {
  const { data, success, errMsg } = await dispatch(request);
  if (data && success) {
    fn(data);
    return data;
  } else {
    errMsg && Toast.fail(errMsg);
  }
};

/**
 * 转换有中间变量的翻译方法
 * @param {Function} t 翻译方法
 * @param {string} key 翻译文档的key
 * @param {Array<string,any>} vars 变量
 * @param {Function} renderVar 回调，参数为拆分变量后字段、变量值、索引
 */
export function transforHasVarsTranslate(t, key, vars, renderVar) {
  const varsKeyObj = vars.reduce((res, item) => {
    res[item[0]] = "xxxxxx";
    return res;
  }, {});
  return t(key, varsKeyObj)
    .split("xxxxxx")
    .map((text, i) => {
      return (
        <Fragment key={i}>
          {text}
          {vars[i] ? renderVar(vars[i][1], i) : null}
        </Fragment>
      );
    });
}

export function replaceParamVal(paramName, replaceWith) {
  var oUrl = location.href.toString();
  var re = eval("/(" + paramName + "=)([^&]*)/gi");
  var nUrl = oUrl.replace(re, paramName + "=" + replaceWith);
  return nUrl;
}

// 分割url参数
export function urlToObj(str) {
  let obj;
  let arr = str.split("?")[1]?.split("&");
  if (arr && arr.length > 0) {
    obj = {};
    for (let i = 0; i < arr.length; i++) {
      let res = arr[i].split("=");
      obj[res[0]] = res[1];
    }
  }
  return {
    url: str.split("?")[0],
    query: obj,
  };
}
